import { Flex } from 'foundations-components/components/Flex';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { useEffect } from 'react';
import { Subscreens } from '../../constants/usage';
import { useProductTypeSearchParam } from '../../hooks/useProductTypeSearchParams';
import { SortDropdown } from '../../search-results/components/SortDropdown';
import { getBaseFilterConfig } from '../utils/BaseFilterConfig';
import { FilterPanelButton } from './FilterPanelButton';
import { BreezeFilter } from './singleUseFilters/BreezeFilter';
import { PortalInstallableFilter } from './singleUseFilters/PortalInstallableFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontFilterBar({
  filterPanelOpen,
  onFilterPanelOpen
}) {
  const params = useSearchParams();
  const productType = useProductTypeSearchParam();
  const baseFilters = getBaseFilterConfig();
  const mismatchingProductSpecificFilters = Object.values(baseFilters).filter(f => 'productType' in f && f.productType !== productType && params.get(f.field));
  useEffect(() => {
    mismatchingProductSpecificFilters.forEach(f => {
      params.delete(f.field);
    });
  }, [mismatchingProductSpecificFilters, params]);
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.FILTER_BAR,
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      "data-test-id": "storefront-filter-bar",
      paddingInline: "600",
      paddingBlock: "400",
      display: "flex",
      flexDirection: "row",
      alignItems: "start",
      marginBlockEnd: "0",
      gap: "400",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexWrap: "wrap",
        columnGap: "800",
        flexGrow: 1,
        children: [/*#__PURE__*/_jsx(PortalInstallableFilter, {}), /*#__PURE__*/_jsx(Flex, {
          blockSize: "40px",
          alignItems: "center",
          marginInlineEnd: "auto",
          children: /*#__PURE__*/_jsx(BreezeFilter, {})
        }), /*#__PURE__*/_jsx(SortDropdown, {})]
      }), !filterPanelOpen && /*#__PURE__*/_jsx(FilterPanelButton, {
        onFilterPanelOpen: onFilterPanelOpen
      })]
    })
  });
}